// | ------------------------------------------------------------------------
// | Product Filters
// | ------------------------------------------------------------------------ 


import { OverlayScrollbars } from 'overlayscrollbars';


var filters = document.querySelector(".product-filters");

if(filters){

    // Set Custom Properties needed to calculate the height of the filters
    var calcFilterHeight = function(){

        var filterHeader = document.querySelector(".product-filters-header");
        var filterFooter = document.querySelector(".product-filters-footer");

        if(filterHeader){
          var filterHeaderHeight = filterHeader.offsetHeight;
          document.documentElement.style.setProperty("--filter-header-height", filterHeaderHeight + "px");
        }else{
          document.documentElement.style.setProperty("--filter-header-height", 0 + "px");
        }

        if(filterFooter){
          var filterFooterHeight = filterFooter.offsetHeight;
          document.documentElement.style.setProperty("--filter-footer-height", filterFooterHeight + "px");
        }else{
          document.documentElement.style.setProperty("--filter-footer-height", 0 + "px");
        }

    };

    // Run on scroll/load/resize
    window.addEventListener("scroll", calcFilterHeight, false);
    window.addEventListener("load", calcFilterHeight, false);
    window.addEventListener("resize", calcFilterHeight, false);



    // Resize sticky filter button when it becomes sticky
    window.onscroll = function() { 
        const el = document.querySelector(".product-filters-column")
        const observer = new IntersectionObserver( 
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
        );
    
        observer.observe(el);
    }


    // Add custom scroll bar to the filters when needed
    OverlayScrollbars(document.querySelector('.product-filters-body'), {
        overflow: {
        x: 'hidden',
        },
        scrollbars: {
        visibility: 'auto',
        autoHide: 'leave',
        }
    }); 

    
    // Open and close filters on mobile devices
    window.addEventListener('load', (event) => {

        // Set variables
        var body = document.querySelector("body");
        var filters = document.querySelector(".product-filters");
        var button = document.querySelector('.product-filters-button');
        var closeButton = document.querySelector('.close-filters-button');
        var windowWidth = document.body.clientWidth;


        // Toggle menu function
        var toggleDrawer = function(){
            body.classList.toggle('filters-open');
            button.classList.toggle('toggled');
            document.documentElement.classList.toggle('no-scroll');
        }

        if(button){

            // Open/close filters using button
            button.addEventListener("click",function(event){
                event.stopPropagation();
                toggleDrawer();
            }, false); 

            // Prevent filters from closing when clicked
            filters.addEventListener("click",function(event){
                event.stopPropagation();
            }, false);         

            // Close filters when clicking off them
            body.addEventListener("click",function(){
                if (body.classList.contains('filters-open')) {
                    toggleDrawer();
                }
            }, false);    
            
            // Close filters when clicking close button
            closeButton.addEventListener("click",function(){
                if (body.classList.contains('filters-open')) {
                    toggleDrawer();
                }
            }, false);          

            // Close filters if window is resized
            window.addEventListener("resize",function(){
                if(document.body.clientWidth !== windowWidth){
                    if (body.classList.contains('filters-open')) {
                        toggleDrawer();
                    }
                }
                windowWidth = document.body.clientWidth;
            });

        }
    });    

}







